import moment from 'moment';

/**
 * Format start/end timestamps into a date range display string
 *
 * @param start - Unix timestamp (seconds)
 * @param end - Unix timestamp (seconds)
 * @returns Formatted string like "Last 7 days" or date range string
 */
export const formatDateRangeDisplay = (start: number, end: number): string => {
  if (!start || !end) return '';

  const duration = moment.duration(moment.unix(end).diff(moment.unix(start)));
  const days = Math.round(duration.asDays());

  // For common ranges, use humanized format
  if (days === 1) return 'Last 24 hours';
  if (days === 7) return 'Last 7 days';
  if (days === 30) return 'Last 30 days';
  if (days === 90) return 'Last 90 days';

  // For custom ranges, show actual date range
  const startDate = moment.unix(start).format('MMM D, YYYY');
  const endDate = moment.unix(end).format('MMM D, YYYY');
  return `${startDate} - ${endDate}`;
};
